module.exports = __webpack_public_path__ + "static/media/English.d7695a0e.svg";